import makeDrawerState from './_makeDrawerState.js';

export const { actions, reducer } = makeDrawerState('drawer');

export default reducer;
